// @ts-strict-ignore
import getWindow from '@u/get-window'
import { isEmpty } from '@u/obj'
import { appName } from '../../__config__/env.json'
import datalayerPush from './data-layer'

/**
 * Only log the GA event on the client.
 *
 * @param {Object} data - The event data to log.
 */
const logTrackEvent = (data) => {
  // eslint-disable-next-line no-console
  if (!isEmpty(getWindow())) console.log('gaEvent', data)
}

export const track = (action, label, value, callback, nonInteractive, category = appName) =>
  getWindow().uSwitchEventTracking
    ? getWindow().uSwitchEventTracking(category, action, label, value, callback, nonInteractive)
    : logTrackEvent({ type: appName, action, label, value, callback, nonInteractive })

const EVENT_NAME = 'gaTriggerEvent'

export const trackEvent = (trackingObject) => {
  if (trackingObject?.tracking) {
    const {
      tracking: { category, action, label },
    } = trackingObject

    datalayerPush({
      event: EVENT_NAME,
      gaEventCategory: category.value,
      gaEventAction: action.value,
      gaEventLabel: label.value,
    })
  }
}

export const gtmTrack = (action, category, label) =>
  trackEvent({
    tracking: {
      category: {
        value: category,
      },
      action: {
        value: action,
      },
      label: { value: label },
    },
  })

export const formatTracking = (tracking, data, trackingKey) => {
  const formattedTracking = {}

  for (const key in tracking[trackingKey]) {
    if (Object.prototype.hasOwnProperty.call(tracking[trackingKey], key)) {
      formattedTracking[key] = getValue(tracking[trackingKey][key], data)
    }
  }

  if (tracking.listLoadedId) {
    // eslint-disable-next-line camelcase
    formattedTracking.list_loaded_id = tracking.listLoadedId
  }

  return formattedTracking
}

export const trackProductClickout = (tracking) => {
  const id = tracking.product_id || tracking
  const product = {}
  product[id] = tracking

  datalayerPush({
    event: 'nerd.product.clicked',
    nerd: {
      event: {
        id: id,
      },
      page: {},
      product,
    },
  })
}

export const trackElementClicked = (elementName, elementText, elementType) => {
  const id = elementName

  datalayerPush({
    event: 'nerd.element.clicked',
    nerd: {
      event: {
        id: id,
      },
      element: {
        [id]: {
          /* eslint-disable camelcase */
          element_name: elementName,
          element_text: elementText,
          element_type: elementType,
          /* eslint-enable camelcase */
        },
      },
    },
  })
}

export const trackTableLoad = (table) => {
  /* eslint-disable camelcase */
  const id = table.list_id
  const product_list = {}
  product_list[id] = table

  datalayerPush({
    event: 'nerd.product_list.loaded',
    nerd: {
      event: {
        id: id,
      },
      page: {},
      product_list,
    },
  })
  /* eslint-enable camelcase */
}
